import { BookOpen, Clock } from "lucide-react";
import { useTracker } from "@ferrivia/auth-web";
import { useTranslation } from "@ferrivia/i18n";
import s from "./ArticleCard.module.css";

export interface ArticleCardProps {
  slotKind: "fixed" | "routed";
  title?: string;
}

export function ArticleCard({ slotKind, title }: ArticleCardProps) {
  const { t } = useTranslation("client");
  const tracker = useTracker();

  if (!title) {
    return (
      <div className={`${s.root} ${s.placeholder}`}>
        <span className={s.thumb} aria-hidden>
          <Clock size={22} strokeWidth={1.6} />
        </span>
        <span className={s.title}>{t("summary.article.comingSoon", "Sisältö tulossa")}</span>
      </div>
    );
  }

  return (
    <div className={s.root}>
      <span className={s.thumb} aria-hidden>
        <BookOpen size={22} strokeWidth={1.6} />
      </span>
      <span className={s.text}>
        <span className={s.title}>{title}</span>
        <button
          type="button"
          className={s.read}
          onClick={() => tracker.track("summary.article_clicked", { slot_kind: slotKind })}
        >
          {t("summary.article.read", "Lue artikkeli")}
        </button>
      </span>
    </div>
  );
}
